import React, { Component } from 'react';
import Top_Bar from '../../Part_Sample/Top_Bar';
import { isEmpty, getModeIcon, getIcon } from '../../Common/Common';
import Select from '../../Part_Sample/Select';
import Display_Conditions from './Components/Display_Conditions';

export default class Edit_Interlock_Input extends Component {
	constructor(props) {
		super(props);
		this.program = {};

		if (this.props.param.program != null) {
			this.program = this.props.param.program
		} else if (this.props.param.interlock.program[this.props.param.program_id] != null) {
			this.program = this.props.param.interlock.program[this.props.param.program_id];
		}

		let exec_condition = 'all';
		let num = 0;
		let duration = 0;

		if (this.program.exec_condition != null) {
			if (isNaN(parseInt(this.program.exec_condition))) {
				exec_condition = this.program.exec_condition;
			} else {
				exec_condition = 'num';
				num = parseInt(this.program.exec_condition);
				if (this.program.condition.length >= 2 && num == 0) {
					// Check that the conditions are >= 2 and if num is still 0, set default num to 2 
					num = 2;
				} else if (this.program.condition.length < 2) {
					// Check that the conditions are < 2, num should be set back to 0
					// i.e. in case user deletes conditions
					num = 0;
				}
			}
		}
		if (this.program.duration != null) duration = this.program.duration;

		//Alex - 12/10/21 - Check to remove empty JSON {} in condition.
		for(let i = 0; i < this.program.condition.length; i++) {
			if(isEmpty(this.program.condition[i])) {
				this.program.condition.splice(i, 1);
			}
		}

		this.state = {
			exec_condition: exec_condition,
			duration: duration,
			num: num, 			// For exec_con num, user has to specify how many 
		}
	}

	handlePrevious = () => {
		let paramTmp = JSON.parse(JSON.stringify(this.props.param));
		paramTmp.op_type = 'input';

		if (paramTmp.program.hasOwnProperty('original_condition')) {
			paramTmp.program.condition = paramTmp.program.original_condition;

			delete paramTmp.program.original_condition;
		}

		this.props.content_handler('Interlock_Summary', paramTmp);
	}

	handleChangeExecCondition = (val) => {
		if (val == 'num') {
			let num = this.state.num;
			if (this.program.condition.length >= 2 && this.state.num == 0) {
				// Check that the conditions are >= 2 and if num is still 0, set default num to 2 
				num = 2;
			} else if (this.program.condition.length < 2) {
				// Check that the conditions are < 2, num should be set back to 0
				// i.e. in case user deletes conditions
				num = 0;
			}
			this.setState({ num: num });
		}

		this.setState({ exec_condition: val });
	}

	handleChangeDuration = (val) => {
		this.setState({ duration: val });
	}

	handleChangeNum = (val) => {
		this.setState({ num: val });
	}

	handleAddInputCondition = () => {
		let exec_condition = this.state.exec_condition
		if (this.state.exec_condition == 'num') {
			exec_condition = this.state.num.toString();
		}

		this.program.exec_condition = exec_condition;
		this.program.duration = parseInt(this.state.duration);

		let param = this.props.param;
		param.condition_index = null;
		param.program = this.program;
		// Remove any temporary condition detail 
		if (param.condition_detail != null) delete param.condition_detail
		this.props.content_handler('Add_Edit_Input_Condition', param);
	}

	handleEditInputCondition = (index) => {
		let exec_condition = this.state.exec_condition
		if (this.state.exec_condition == 'num') {
			exec_condition = this.state.num.toString();
		}

		this.program.exec_condition = exec_condition;
		this.program.duration = parseInt(this.state.duration);

		let param = this.props.param;
		param.condition_index = index;
		param.program = this.program;
		// Remove any temporary condition detail
		if (param.condition_detail != null) delete param.condition_detail
		this.props.content_handler('Add_Edit_Input_Condition', param);
	}

	handleRegister = () => {
		if(this.props.param.program.condition.length == 0) {
			window.app.showToast(this.props.receiver.getString('no_condition'), 3000);
			return;
		}

		let exec_condition = this.state.exec_condition
		if (this.state.exec_condition == 'num') {
			if (this.state.num == null || this.state.num == undefined || this.state.num < 2) {
				window.app.showToast(this.props.receiver.getString('no_min_num'), 3000, 60);
				return;
			} else {
				exec_condition = this.state.num.toString();
			}
		}

		this.program.exec_condition = exec_condition;
		this.program.duration = parseInt(this.state.duration);

		let param = this.props.param;
		param.op_type = 'input';
		param.program = this.program;

		this.props.content_handler('Interlock_Summary', param);
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		// Determine device orientation
		let is_landscape = this.props.width > this.props.height;

		let max_height = this.props.height - 120;
		if (max_height < 200) max_height = 200;

		const exec_condition_select = [];
		exec_condition_select.push(<option value={'all'} key={'all'}>{this.props.receiver.getString('allInputsValid')}</option>);
		exec_condition_select.push(<option value={'one'} key={'one'}>{this.props.receiver.getString('atLeastOneInputValid')}</option>);
		exec_condition_select.push(<option value={'num'} key={'num'}>{this.props.receiver.getString('num')}</option>);

		const duration_select = [];
		for (let i = 0; i <= 60; i++) {
			duration_select.push(<option value={i} key={'duration-' + i}>{i}</option>);
		}

		const num_select = [];
		if (this.program.condition.length >= 2) {
			for (let j = 2; j <= this.program.condition.length; j++) {
				num_select.push(<option value={j} key={'num-' + j}>{j}</option>);
			}
		}

		// Handle weird span display padding top
		let is_show_paddingtop = false;
		if (this.program.condition.length > 0 || (this.program.condition.length == 1 && isEmpty(this.program.condition[0]))) {
			is_show_paddingtop = true;
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('condition')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					<div className='noScrollBar' style={{ cursor: 'pointer', width: '100%', overflow: "auto", height: is_landscape ? 'auto' : max_height, paddingBottom: is_landscape ? 60 : 0}}>
						<div style={{ textAlign: 'left', marginLeft: 20 }}>
							<div>
								<span className='title'>{this.props.receiver.getString('exec_condition')}</span>
							</div>
							<Select
								style={{ marginTop: 5 }}
								select_style={{ width: this.props.width - 40, height: 50 }}
								options={exec_condition_select}
								value={this.state.exec_condition}
								onSelect={this.handleChangeExecCondition}
							/>
							<div style={{ display: this.state.exec_condition == 'num' ? 'block' : 'none', textAlign: 'left', marginLeft: 20, marginTop: 10 }}>
								<div style={{ display: 'inline-block' }}>
									<span className='subtitle'>{this.props.receiver.getString('num_cond')}</span>
								</div>
								<Select
									style={{ display: 'inline-block', marginLeft: 5, width: 60 }}
									select_style={{ width: 60, height: 30 }}
									options={num_select}
									value={this.state.num}
									onSelect={this.handleChangeNum}
								/>
							</div>
						</div>
						<div style={{ textAlign: 'left', marginLeft: 20, marginTop: 20 }}>
							<div style={{ display: 'inline-block', width: this.props.width - 105 }}>
								<span className='title'>{this.props.receiver.getString('timer')}</span>
							</div>
							<Select
								style={{ display: 'inline-block', marginLeft: 5, width: 60 }}
								options={duration_select}
								value={this.state.duration}
								onSelect={this.handleChangeDuration}
							/>
							<div>
								<span className='footnote' style={{ fontSize: 14 }}>{this.props.receiver.getString('timer_explanation')}</span>
							</div>
						</div>
						<div style={{ textAlign: 'left', marginLeft: 20, marginTop: 15, }}>
							<div>
								<span className='title'>{this.props.receiver.getString('condition')}</span>
							</div>
							<div className='noScrollBar' style={{ overflow: 'auto', width: this.props.width - 40, height: this.state.exec_condition == 'num' ? this.props.height - 400 : this.props.height - 360, marginTop: 10, paddingTop: is_show_paddingtop ? 0 : 0.1, boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)', }}>
								<Display_Conditions
									program={this.program}
									width={this.props.width}
									height={this.props.height}
									receiver={this.props.receiver}
									handleEditInputCondition={this.handleEditInputCondition}
								/>
								<div id='add_input_condition' onClick={this.handleAddInputCondition} style={{ marginTop: 20, marginBottom: 20, padding: 5, width: this.props.width - 80, marginLeft: 'auto', marginRight: 'auto', minWidth: 30, verticalAlign: 'top', textAlign: 'center', cursor: 'pointer', border: '1px solid ' + this.props.colours.appBlue }}>
									<span className='footnote'>{this.props.receiver.getString('add_input_condition_instr')}</span>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>
		)
	}
}